import { baseFontSize, bodyFontFamily } from "../constants"

export default `
  body {
    font-size: ${baseFontSize}px;
    font-family: ${bodyFontFamily};
    text-rendering: geometricPrecision;
  }
`
